import { CSSProperties } from 'react';

export const styles: { [key: string]: CSSProperties } = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: '100vh',
    width: '100%',
    padding: '20px',
    boxSizing: 'border-box',
    backgroundColor: '#8BCF00',
    fontFamily: 'Arial, sans-serif',
  },
  content: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
  },
  output: {
    fontSize: '72px',
    wordWrap: 'break-word',
    maxWidth: '80vw',
    textAlign: 'center',
    transform: 'scale(0.8, 1.03)',
    filter: 'blur(1px) contrast(110%)',
    letterSpacing: '-0.5px',
    fontFamily: 'Arial, sans-serif',
  },
  controls: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    marginBottom: '50px',
  },
  input: {
    width: '200px',
    padding: '10px 15px',
    border: 'none',
    borderRadius: '25px',
    fontSize: '16px',
    outline: 'none',
    boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
    transition: 'all 0.3s ease',
    marginRight: '10px',
    backgroundColor: '#FFFFFF',
    color: '#000',
    fontFamily: 'Arial, sans-serif',
  },
  button: {
    backgroundColor: '#4a7a00',
    border: 'none',
    borderRadius: '25px',
    cursor: 'pointer',
    padding: '10px 20px',
    fontSize: '16px',
    color: '#000',
    transition: 'all 0.3s ease',
    transform: 'scale(0.8, 1.05)',
    filter: 'blur(0.5px) contrast(120%)',
    letterSpacing: '-0.5px',
    textTransform: 'lowercase',
    fontFamily: 'Arial, sans-serif',
  },
  footer: {
    fontSize: '20px',
    transform: 'scale(0.9, 1.03)',
    filter: 'blur(0.5px) contrast(110%)',
    letterSpacing: '-0.3px',
    fontFamily: 'Arial, sans-serif',
    padding: '10px',
  },
  above_footer: {
    fontSize: '20px',
    transform: 'scale(0.9, 1.03)',
    filter: 'blur(0.5px) contrast(110%)',
    letterSpacing: '-0.3px',
    fontFamily: 'Arial, sans-serif',
  }
};